import api from '..'

export async function deletePixel(id: string): Promise<void> {
  await api.delete(`/pixels/${id}`)
}
